import React from 'react';
import * as ST from './styled';
var DefaultArrow = function (_a) {
    var previousSlide = _a.previousSlide, nextSlide = _a.nextSlide;
    return (<ST.Wrapper onClick={previousSlide || nextSlide}>
            <ST.ArrowSvg type={previousSlide ? 'left' : 'right'}/>
        </ST.Wrapper>);
};
export default DefaultArrow;
